import { account } from './en/account';
import { acts } from './en/acts';
import { common } from './en/common';
import { kit } from './en/kit';
import { legacy } from './en/legacy';
import { notes } from './en/notes';
import { push } from './en/push';
import { resolution } from './en/resolution';
import { suggestions } from './en/suggestions';
import { shell } from './en/shell';
import { palette } from './en/palette';
import { create } from './en/create';
import { auth } from './en/auth';
import { pickers } from './en/pickers';
import { itemActions } from './en/itemActions';
import { viewControls } from './en/viewControls';
import { criteria } from './en/criteria';
import { values } from './en/values';
import { feed } from './en/feed';
import { checklist } from './en/checklist';
import { fields } from './en/fields';
import { access } from './en/access';
import { contacts } from './en/contacts';
import { agentKeys } from './en/agentKeys';
import { item } from './en/item';
import { lists } from './en/lists';
import { lenses } from './en/lenses';
import { work } from './en/work';
import { views } from './en/views';
import { search } from './en/search';
import { tags } from './en/tags';
import { map } from './en/map';
import { admin } from './en/admin';
import { groups } from './en/groups';
import { invite } from './en/invite';
import { connect } from './en/connect';
import { flows } from './en/flows';
import { boards } from './en/boards';
import { phases } from './en/phases';
import { ceremonies } from './en/ceremonies';
import { plans } from './en/plans';
import { attributes } from './en/attributes';
import { facts } from './en/facts';
import { modules } from './en/modules';
import { mail } from './en/mail';
import { flowErrors } from './en/flowErrors';
import { itemErrors } from './en/itemErrors';
import { accessErrors } from './en/accessErrors';
import { accountErrors } from './en/accountErrors';
import { proposalErrors } from './en/proposalErrors';

/**
 * **The English catalog: the source** (docs/I18N.md). Its keys are the type
 * (`MessageKey`), and the `{slot}` names in its entries are the arguments each
 * key takes. One area file per part of the product under `./en/`, spread here;
 * a new area adds its file and one line below, and its German twin in `de.ts`.
 *
 * Key naming: `<area>.<thing>.<variant>`, dotted, lower camel inside a segment.
 */
export const en = {
  ...common,
  ...kit,
  ...account,
  ...acts,
  ...resolution,
  ...push,
  ...suggestions,
  ...notes,
  ...legacy,
  // stage 2, slot components-a (docs/I18N.md §11)
  ...shell,
  ...palette,
  ...create,
  ...auth,
  ...pickers,
  ...itemActions,
  ...viewControls,
  ...criteria,
  ...values,
  // stage 2, slot components-b (docs/I18N.md §11)
  ...feed,
  ...checklist,
  ...fields,
  ...access,
  ...contacts,
  ...agentKeys,
  // stage 2, slot item (docs/I18N.md §11)
  ...item,
  // stage 2, slot views (docs/I18N.md §11)
  ...lists,
  ...lenses,
  ...work,
  ...views,
  ...search,
  ...tags,
  ...map,
  // stage 2, slot people (docs/I18N.md §11)
  ...admin,
  ...groups,
  ...invite,
  ...connect,
  // stage 2, slot flows (docs/I18N.md §11)
  ...flows,
  ...boards,
  ...phases,
  ...ceremonies,
  ...plans,
  // stage 2, the words the domain and src/lib hand the surfaces
  ...attributes,
  ...facts,
  ...modules,
  ...mail,
  // stage 2, the refusals outside the resolver (docs/I18N.md §6)
  ...flowErrors,
  ...itemErrors,
  ...accessErrors,
  ...accountErrors,
  ...proposalErrors,
} as const;
